<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-12">
            <h1 class="mainTitle">Reports</h1>
            <p class="text-muted">
              Export Excel reports. Only users with permission can export.
            </p>
          </div>
        </div>
      </section>

      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-white">
              <div class="panel-heading">
                <h5 class="panel-title">Daily Reservations</h5>
              </div>
              <div class="panel-body">
                <div class="form-group">
                  <label>Date</label>
                  <input v-model="dailyDate" type="date" class="form-control" />
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="!dailyDate || loading.daily"
                  @click="exportDailyReservations"
                >
                  <span
                    v-if="loading.daily"
                    class="fa fa-spinner fa-spin"
                  ></span>
                  <span v-else class="fa fa-download"></span>
                  <span style="margin-left: 5px">Export</span>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="panel panel-white">
              <div class="panel-heading">
                <h5 class="panel-title">User Reservations</h5>
              </div>
              <div class="panel-body">
                <div class="form-group">
                  <label>User ID</label>
                  <input
                    v-model.number="userId"
                    type="number"
                    class="form-control"
                    placeholder="Enter User ID"
                  />
                </div>
                <div class="form-group">
                  <label>Date (optional)</label>
                  <input v-model="userDate" type="date" class="form-control" />
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="loading.user"
                  @click="exportUserReservations"
                >
                  <span
                    v-if="loading.user"
                    class="fa fa-spinner fa-spin"
                  ></span>
                  <span v-else class="fa fa-download"></span>
                  <span style="margin-left: 5px">Export</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="panel panel-white">
              <div class="panel-heading">
                <h5 class="panel-title">Service Reservations</h5>
              </div>
              <div class="panel-body">
                <button
                  class="btn btn-primary"
                  :disabled="loading.service"
                  @click="exportServiceReservations"
                >
                  <span
                    v-if="loading.service"
                    class="fa fa-spinner fa-spin"
                  ></span>
                  <span v-else class="fa fa-download"></span>
                  <span style="margin-left: 5px">Export</span>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="panel panel-white">
              <div class="panel-heading">
                <h5 class="panel-title">Vendors</h5>
              </div>
              <div class="panel-body">
                <button
                  class="btn btn-primary"
                  :disabled="loading.vendors"
                  @click="exportVendors"
                >
                  <span
                    v-if="loading.vendors"
                    class="fa fa-spinner fa-spin"
                  ></span>
                  <span v-else class="fa fa-download"></span>
                  <span style="margin-left: 5px">Export</span>
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="panel panel-white">
              <div class="panel-heading">
                <h5 class="panel-title">Doctors</h5>
              </div>
              <div class="panel-body">
                <button
                  class="btn btn-primary"
                  :disabled="loading.doctors"
                  @click="exportDoctors"
                >
                  <span
                    v-if="loading.doctors"
                    class="fa fa-spinner fa-spin"
                  ></span>
                  <span v-else class="fa fa-download"></span>
                  <span style="margin-left: 5px">Export</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/Axios";

export default {
  name: "ReportsIndex",
  data() {
    return {
      dailyDate: "",
      userId: null,
      userDate: "",
      loading: {
        daily: false,
        user: false,
        service: false,
        vendors: false,
        doctors: false,
      },
      errorMessage: null,
    };
  },
  methods: {
    async downloadBlob(url, payload, fallbackName) {
      this.errorMessage = null;
      try {
        const response = await axios.post(url, payload, {
          responseType: "blob",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
        const blob = new Blob([response.data], {
          type:
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const contentDisposition =
          response.headers["content-disposition"] || "";
        const fileNameMatch = contentDisposition.match(
          /filename\*=UTF-8''([^;\n]+)|filename="?([^";\n]+)"?/i
        );
        const fileName = decodeURIComponent(
          (fileNameMatch && (fileNameMatch[1] || fileNameMatch[2])) ||
            fallbackName
        );

        const urlObject = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlObject;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlObject);
      } catch (e) {
        this.errorMessage =
          (e && e.response && e.response.data && e.response.data.message) ||
          "Failed to download report.";
        // Fallback attempt: if backend returned JSON error in blob
        if (e && e.response && e.response.data instanceof Blob) {
          try {
            const text = await e.response.data.text();
            const json = JSON.parse(text);
            this.errorMessage = json.message || this.errorMessage;
          } catch (_) {
            // ignore
          }
        }
        if (e && e.response && e.response.status) {
          console.error(
            "Report download failed:",
            e.response.status,
            e.response.headers,
            e.response.data
          );
        } else {
          console.error("Report download failed:", e);
        }
      }
    },
    async exportDailyReservations() {
      this.loading.daily = true;
      await this.downloadBlob(
        "/api/admin/report/daily-reservations/export",
        { date: this.dailyDate },
        `daily-reservations-${this.dailyDate}.xlsx`
      );
      this.loading.daily = false;
    },
    async exportUserReservations() {
      this.loading.user = true;
      const payload = {};
      if (this.userId) payload.user_id = this.userId;
      if (this.userDate) payload.date = this.userDate;
      const nameSuffix =
        this.userId || this.userDate
          ? `${this.userId || this.userDate}`
          : "all";
      await this.downloadBlob(
        "/api/admin/report/user-reservations/export",
        payload,
        `user-reservations-${nameSuffix}.xlsx`
      );
      this.loading.user = false;
    },
    async exportServiceReservations() {
      this.loading.service = true;
      await this.downloadBlob(
        "/api/admin/report/service-reservations/export",
        {},
        "service-reservations.xlsx"
      );
      this.loading.service = false;
    },
    async exportVendors() {
      this.loading.vendors = true;
      await this.downloadBlob(
        "/api/admin/report/statistics/vendors/export",
        {},
        "vendors.xlsx"
      );
      this.loading.vendors = false;
    },
    async exportDoctors() {
      this.loading.doctors = true;
      await this.downloadBlob(
        "/api/admin/report/statistics/doctors/export",
        {},
        "doctors.xlsx"
      );
      this.loading.doctors = false;
    },
  },
};
</script>
